import { Loader2 } from 'lucide-react';
import StatusBadge from './StatusBadge';
import SummaryCard from './SummaryCard';

const ProgressStep = ({ activeJobStatus, selectedFile }) => {
  return (
    <div className="rounded-lg border border-gray-200 bg-bg-surface p-6">
      <div className="flex items-start gap-4">
        <div className="rounded-lg bg-blue-50 p-3 text-blue-600">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-semibold text-text-primary">Import in progress</h2>
            {activeJobStatus?.status && <StatusBadge status={activeJobStatus.status} />}
          </div>
          <p className="mt-1 text-sm text-text-secondary">This screen refreshes automatically every 2 seconds.</p>

          <div className="mt-6">
            <div className="mb-2 flex items-center justify-between text-sm text-text-secondary">
              <span>{activeJobStatus?.sourceFilename || selectedFile?.name || 'Import job'}</span>
              <span>{activeJobStatus?.progress || 0}%</span>
            </div>
            <div className="h-3 w-full overflow-hidden rounded-full bg-gray-100">
              <div
                className="h-full rounded-full bg-primary-500 transition-all"
                style={{ width: `${activeJobStatus?.progress || 0}%` }}
              />
            </div>
          </div>

          <div className="mt-6 grid gap-4 md:grid-cols-4">
            <SummaryCard label="Processed" value={activeJobStatus?.counts?.processed || 0} />
            <SummaryCard label="Success" value={activeJobStatus?.counts?.success || 0} />
            <SummaryCard label="Failed" value={activeJobStatus?.counts?.failed || 0} />
            <SummaryCard label="Skipped" value={activeJobStatus?.counts?.skipped || 0} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressStep;
